import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

interface UserAddressMapProps {
  address?: string;
  location?: string;
}

const UserAddressMap: React.FC<UserAddressMapProps> = ({ address, location }) => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const map = useRef<mapboxgl.Map | null>(null);

  // For now, we'll skip the map functionality and just show the address
  // useEffect(() => {
  //   // Map functionality would go here with proper Mapbox token
  // }, [address]);

  if (!address) {
    return null;
  }

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-muted-foreground">Address Location</p>
      <div className="p-4 bg-muted/30 rounded-lg border">
        <p className="text-sm">{address}</p>
        <p className="text-xs text-muted-foreground mt-1">
          Map view requires Mapbox configuration
        </p>
      </div>
    </div>
  );
};

export default UserAddressMap;